import { Subject } from 'rxjs';

const loginChange = new Subject<boolean>();

export default loginChange;
